export const mergeMissionAndEventMapping = ({
  missionAndEventMapping = [
    // Example:
    // {
    //     "hot_topic_shared": ["692e561e1ab98ec19a02f1ca.692e561e1ab98ec19a02f1cb.692e561e1ab98ec19a02f1cc"]
    // }
  ],
  defaultValue = {}
}) => {
  const mergedMapping = { ...defaultValue };
  missionAndEventMapping.forEach(mapping => {
    Object.keys(mapping).forEach(key => {
      if (!mergedMapping[key]) {
        mergedMapping[key] = [];
      }
      mergedMapping[key] = Array.from(new Set([...mergedMapping[key], ...mapping[key]]));
    });
  });

  return mergedMapping;
};
